// ###### IMPORTS
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from 'connections/AuthContext';
import routes_web from 'connections/routes_web';
import { getTrips } from './moduleServices/travel_services';

// imported components
import TabTravelOverview from './tab_overview/main_overview';
import TabTrips from './tab_trips/main_trips';
import TabExplore from './tab_explore/main_explore';
import TabTravelSettings from './tab_settings/main_settings';
import MainTravelNotes from './tab_notes/main_notes';
import NavbarTop from './moduleComponents/NavbarTop';
import NavbarBottom from './moduleComponents/NavbarBottom';


// ###### MAIN COMPONENT
const TravelMain = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [activeTab, setActiveTab] = useState('overview');
  const [trips, setTrips] = useState([]);
  const [isTripsLoading, setIsTripsLoading] = useState(true);

  // ### API REQUESTS
  const fetchTrips = async () => {
    setIsTripsLoading(true);
    try {
      const tripsData = await getTrips();
      setTrips(tripsData);
    } catch (error) {
      console.error('Failed to load trips:', error);
    } finally {
      setIsTripsLoading(false);
    }
  };

  useEffect(() => {
    fetchTrips();
  }, []);

  // ### HANDLERS
  const handleTabChange = (tab) => setActiveTab(tab);

  // ### RETURN VIEW
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <div className="max-w-5xl w-full mx-auto pt-14 pb-20">

        {/* Tabs Content */}
        {activeTab === 'overview' && (
          <TabTravelOverview 
            trips={trips}
            isTripsLoading={isTripsLoading}
          />
        )}
        {activeTab === 'trips' && (
          <TabTrips
            trips={trips}
            isTripsLoading={isTripsLoading}
            fetchTrips={fetchTrips}
          />
        )}
        {activeTab === 'explore' && <TabExplore />}
        {activeTab === 'notes' && <MainTravelNotes />}
        {activeTab === 'settings' && (
          <TabTravelSettings
            trips={trips}
            fetchTrips={fetchTrips}
          />
        )}

      </div>

      {/* Navbar Top */}
      <NavbarTop
        title="Travel"
        onHomeClick={() => navigate(routes_web.accounts_home)}
        onLogoutClick={logout}
        handleTabChange={handleTabChange}
      />

      {/* Navbar Bottom */}
      <NavbarBottom activeTab={activeTab} handleTabChange={handleTabChange} />

    </div>
  );
};

export default TravelMain;